module.exports = __webpack_public_path__ + "static/media/Test4.26e17fb0.bmp";